import { useEffect } from "react";
import { isIOS } from "react-device-detect";
import { Outlet, useLocation } from "react-router-dom";
import { NewsProvider } from "./NewsContext";
import scrollToTop from "utils/scrollToTop";

const NewsLayout = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		scrollToTop();
		if (!isIOS) {
			return;
		}

		const frameId =
			typeof window.requestAnimationFrame === "function"
				? window.requestAnimationFrame(scrollToTop)
				: undefined;
		const timeoutId = window.setTimeout(scrollToTop, 100);

		return () => {
			if (frameId !== undefined) {
				window.cancelAnimationFrame(frameId);
			}
			window.clearTimeout(timeoutId);
		};
	}, [pathname]);

	return (
		<NewsProvider>
			<Outlet />
		</NewsProvider>
	);
};

export default NewsLayout;
